import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	SSID_CONFIGURE_MODAL_EVENT,
	SSID_CREATE_MODAL_EVENT,
	SSID_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open the Add SSID form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidCreateModal(command, envelope) {
	return openResourceModal(SSID_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open the Configure SSID form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidConfigureModal(command, envelope) {
	return openResourceModal(SSID_CONFIGURE_MODAL_EVENT, command, envelope);
}

/**
 * Open the SSID delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidDeleteModal(command, envelope) {
	return openResourceModal(SSID_DELETE_MODAL_EVENT, command, envelope);
}

/**
 * Report an SSID modal outcome.
 * @param {'modal.cancelled'|'modal.saved'} eventType lifecycle event
 * @return {Promise<object|null>} agent response
 */
export function reportSsidModalLifecycle(eventType) {
	return reportActiveAgentModalLifecycle(eventType);
}
